import React from "react";
import { MoreHoriz } from "@mui/icons-material";
import { Grid, IconButton, Menu } from "@mui/material";

interface IProps {
    children?: React.ReactNode
}

const CustomPopupMenu: React.FC<IProps> = (props: IProps) => {
    const anchorEl = React.useRef<HTMLButtonElement>(null);
    const [open, setOpen] = React.useState(false);

    const handleClose = (event: React.MouseEvent<EventTarget>) => {
        if (anchorEl.current && anchorEl.current.contains(event.target as HTMLElement)) {
            return;
        }
        setOpen(false);
    };

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const prevOpen = React.useRef(open);
    React.useEffect(() => {
        if (prevOpen.current === true && open === false && anchorEl.current) {
            anchorEl.current?.focus();
        }
        prevOpen.current = open;
    }, [open]);

    return (
        <Grid display="flex">
            <IconButton
                ref={anchorEl}
                aria-haspopup="true"
                aria-label="FilterList"
                onClick={handleToggle}
                aria-controls={open ? 'basic-menu' : undefined}
            >
                <MoreHoriz />
            </IconButton>
            <Menu
                open={open}
                id="menu-appbar"
                onClose={handleClose}
                anchorReference={null}
                anchorEl={anchorEl.current}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
                <Grid onClick={handleClose}>
                    {props.children}
                </Grid>
            </Menu>
        </Grid>
    );
}

export default CustomPopupMenu;
